import colors, { themeColor } from "./design";

// export const caseStatusValues = ['CREATED', 'MEDIATION', 'EVIDENCE',
// 'ARGUMENT', 'COMPLETED', 'ARCHIVED'];
export const caseStatusValues = [
  "FILING",
  "NOTICE",
  "PLEADINGS",
  "EVIDENCE",
  "ARGUMENTS",
  "COMPLETED",
];

// export const taskStatusValues = ['CREATED', 'IN PROCESS', 'COMPLETED', 'ARCHIVED'];
export const taskStatusValues = [
  "CREATED",
  "IN PROCESS",
  "COMPLETED",
  "EXPIRED",
];

export const noticeStatusValues = [
  "REQUEST RECEIVED",
  "DRAFTING",
  "SENT",
  "NEGOTIATION",
  "COMPLETED",
];

export const caseStatusColors = {
  // CREATED: themeColor(colors.created),
  // MEDIATION: 'pink',
  // EVIDENCE: 'violet',
  // ARGUMENT: 'indigo',
  // COMPLETED: 'green',
  // ARCHIVED: 'gray',
  // CREATED: themeColor(colors.created),
  FILING: "pink",
  NOTICE: "red",
  EVIDENCE: "violet",
  ARGUMENT: "indigo",
  COMPLETED: "green",
  PLEADINGS: "gray",
};

export const noticeStatusColors = {
  // CREATED: themeColor(colors.created),
  // DRAFT: 'pink',
  // SENT: 'violet',
  // NEGOTIATION: 'indigo',
  // CONCLUDED: 'green',
  "REQUEST RECEIVED": "gray",
  DRAFTING: "pink",
  SENT: "violet",
  NEGOTIATION: "indigo",
  COMPLETED: "green",
};

export const noticeTypeColors = {
  // INCOMING: 'green',
  // OUTGOING: 'pink',
  Incoming: "green",
  Outgoing: "pink",
};

export const noticeRequestStatusColors = {
  CREATED: themeColor(colors.created),
  APPROVED: "green",
  REJECTED: "red",
};

export const agreementStatusColors = {
  CREATED: "#1b6f8d",
  // DRAFT: 'pink',
  // SIGNATURE: 'violet',
  // SIGNED: 'green',
  SENT: "#1b6f8d",
  DECLINED: "#1b6f8d",
  PARTIALLYCOMPLETED: "#1b6f8d",
  COMPLETED: "#1b6f8d",
  CANCELLED: "#1b6f8d",
};

export const getStatusText = (status) => {
  switch (status) {
    case "CREATED":
      return "Initiated";
      break;
    case "Review":
      return "Under Review";
      break;
    case "Approval":
      return "Pending Approval";
      break;
    case "Signature":
      return "Finalised";
      break;
    case "SENT":
      return "Pending Signature";
      break;
    case "CANCELLED":
      return "Cancelled";
      break;
    case "SIGNED":
      return "Completed";
    case "PARTIALLYCOMPLETED":
      return "Partially completed";
    case "RENEWED":
      return "Renewed";
      case "CLOSED":
      return "CLOSED";
    // Add more cases as needed
    default:
      return "Under Review";
  }
};
export const getStatusColor = (status) => {
  switch (status) {
    case "CREATED":
      return "#1b6f8d";
      break;
    case "Review":
      return "#1b6f8d";
      break;
    case "Approval":
      return "#1b6f8d";
      break;
    case "Signature":
      return "#1b6f8d";
      break;
    case "SENT":
      return "#1b6f8d";
      break;
    case "CANCELLED":
      return "#1b6f8d";
      break;
    case "SIGNED":
      return "#1b6f8d";
      break;
    case "PARTIALLYCOMPLETED":
      return "#1b6f8d";
      break;
    // Add more cases as needed
    default:
      return "#1b6f8d";
  }
};

export const taskStatusColors = {
  CREATED: themeColor(colors.created),
  "IN PROCESS": themeColor(colors["in process"]),
  COMPLETED: themeColor(colors.completed),
  // ARCHIVED: 'gray',
  EXPIRED: "red",
};

export const moduleColors = {
  case: themeColor(colors.case),
  agreement: themeColor(colors.agreement),
  notice: themeColor(colors.notice),
  task: themeColor(colors.task),
  cases: themeColor(colors.cases),
  agreements: themeColor(colors.agreements),
  notices: themeColor(colors.notices),
  tasks: themeColor(colors.tasks),
};
